import React from "react";
import { OrbitLoaderComponent } from "../../utils/orbitLoader";
import "./LoadingButton.css";

const LoadingButton = ({
  isLoading,
  children,
  disabled,
  className = "",
  loaderPosition = "left", // left, right, center
  useSimpleSpinner = false, // Basit spinner kullanımı için
  ...props
}) => {
  return (
    <button
      className={`loading-btn ${className}`}
      disabled={disabled || isLoading}
      {...props}
    >
      {isLoading ? (
        <div className="loading-spinner">
          {loaderPosition === "left" &&
            (useSimpleSpinner ? (
              <div className="simple-spinner"></div>
            ) : (
              <OrbitLoaderComponent size="small" showPath={false} />
            ))}
          <span>{children}</span>
          {loaderPosition === "right" &&
            (useSimpleSpinner ? (
              <div className="simple-spinner"></div>
            ) : (
              <OrbitLoaderComponent size="small" showPath={false} />
            ))}
        </div>
      ) : (
        children
      )}
    </button>
  );
};

export default LoadingButton;
